import { CampaignService } from "@entities/campaigns/lib/services/Campaign.service";
import { useMutation } from "@shared/lib/hooks";
import { BackednResponse } from "@shared/lib/types";
import {
  IBankVerification,
  ICheckBankDetailsRequest,
} from "@shared/lib/types/briefCampains";

export function useCheckBankDetails() {
  const {
    mutate: checkBankDetails,
    isLoading: isChecking,
    isSuccess,
    isError,
    error,
    data,
  } = useMutation<ICheckBankDetailsRequest, BackednResponse<IBankVerification>>({
    mutationFn: async (request: ICheckBankDetailsRequest) => {
      return await CampaignService.checkBankDetails(request);
    },
    options: { skipInvalidation: true },
  });

  return {
    checkBankDetails,
    isChecking,
    isSuccess,
    isError,
    error,
    data,
  };
}
